import { useCallback, useEffect, useState } from 'react'
import { getKyousouApiClient, handleError, ApiErrorResponse } from '../../../services/network'
import { useSnackBar } from '../../../providers/snack_bar_provider'
import { FaqItem } from '../../../clients/kyousou_api_client'

const useFaq = (): [Array<{ faqs: Array<FaqItem>; category: string }>, boolean] => {
  const { showSnackBar } = useSnackBar()
  const [loading, setLoading] = useState(false)
  const [faq, setFaq] = useState<Array<{ faqs: Array<FaqItem>; category: string }>>(
    []
  )

  const load = useCallback(async () => {
    setLoading(true)
    try {
      const apiClient = getKyousouApiClient()
      const response = await apiClient.faqs.faqsList()
      const data = response.data.data || []
      
      const categories = new Set(data.map((item: FaqItem) => item.category))
      setFaq(
        Array.from(categories).map((category: string) => {
          return {
            category: category,
            faqs: data.filter((faq: FaqItem) => faq.category === category),
          }
        })
      )
    } catch (error) {
      handleError(error as ApiErrorResponse, showSnackBar)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    load()
  }, [load])

  return [faq, loading]
}

export default useFaq